import React, {Component, Fragment} from 'react';
import './i18n';
import { withTranslation } from "react-i18next";
import {MemoryRouter,Route, Switch} from 'react-router-dom';
import ODB from './Components/FiberLine/ODB'
import FiberProvider from './Components/FiberLine/FiberProvider'
import PersonalityVerification from './Components/FiberLine/PersonalityVerification'
import ContactInfo from './Components/FiberLine/ContactInfo'
import Thankyou from './Components/FiberLine/Thankyou'
import {Layout} from 'antd';
import {Row, Col} from 'antd';

import WizardForm from './Components/FiberLine/WizardForm';
import { Container } from 'react-bootstrap';
/*const store = createStore(
  lineState,
  applyMiddleware(createLogger())
);*/


class App extends Component {
  render() {
    return (
      <Container>
        <MemoryRouter>
          {/* <Row> */}
                    {/* <header>
                        <Link to="/">Home</Link> <br/>
                        <Link to="/fiberprovider/:hhh">fiberprovider</Link><br/>
                        <Link to="/personalityverification">personalityverification</Link><br/>
                        <Link to="/contactinfo">contactinfo</Link><br/>
                        <Link to="/thankyou">thankyou</Link><br/>
                  
                        <hr />
                    </header> */}
                    {/* <Provider store={store}> */}
                      <Switch>
                          <Route path="/" exact render={props => <WizardForm onSubmit={this.showResults} />}/>
                          <Route path="/fiberprovider/:id" component={FiberProvider}/>
                          <Route path="/personalityverification" component={PersonalityVerification}/>
                          <Route path="/contactinfo" component={ContactInfo}/>
                          <Route path="/thankyou" component={Thankyou}/>
                      </Switch>
                    {/* </Provider> */}
          {/* </Row> */}
        </MemoryRouter>
      </Container>
    )
  }
}
export default withTranslation()(App)